import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import classnames from 'classnames';
import dynamic from 'next/dynamic';
import { connect } from 'react-redux';
import type { FiltersConfigState } from '@/reducers/filtersConfig';
import type { RootState } from '@/reducers/index';
import type { SearchState } from '@/reducers/search';
import { OrderSelector } from '../Filters/OrderSelector';
import ownClasses from './top-bar.module.scss';
interface StateProps {
  noOfAds: number;
  search: SearchState;
  filtersConfig: FiltersConfigState;
}
const SavedSearchButton = dynamic(() => import('../SavedSearchButton'));
export const TopBarComponent: FC<StateProps> = props => {
  const $ = _c(9);
  const t0 = props.noOfAds == 0;
  let t1;
  if ($[0] !== t0) {
    t1 = classnames("top-bar", ownClasses["top-bar"], {
      [ownClasses["no-ads"]]: t0
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.filtersConfig || $[3] !== props.search) {
    t2 = <SavedSearchButton search={props.search} filtersConfig={props.filtersConfig} />;
    $[2] = props.filtersConfig;
    $[3] = props.search;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <OrderSelector />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
TopBarComponent.displayName = 'TopBar';
export default connect<StateProps, never, unknown, RootState>(state => ({
  search: state.search,
  noOfAds: state.items.total,
  filtersConfig: state.filtersConfig
}))(TopBarComponent);